<template>
  <div class="nav">
    <div class="w">
      <div>
      <img :src="hrefurl+'/public/footer_home/logo_en.png'" alt=""/>
    </div>
    <ul>
      <li>
        <span class="headerItem" @click="()=>this.$router.push('/')">
          <img :src="hrefurl+'/public/icon/shouye.png'" alt=""/>
          <span>Home</span>
        </span>
      </li>
      <li>
        <span class="headerItem" @click="web">
            <img :src="hrefurl+'/public/icon/website.png'" alt=""/>
            <span>Website</span>
          </span>
      </li>
      <li>
          <span class="headerItem" @click="()=>this.$router.push('/exhibitor')">
            <img :src="hrefurl+'/public/icon/zhanshang.png'" alt=""/>
            <span>Exhibitor</span>
          </span>
      </li>
      <li>
        <span class="headerItem" @click="()=>this.$router.push('/exhibit')">
          <img :src="hrefurl+'/public/icon/zhanpin.png'" alt=""/>
          <span>Product Categories</span>
        </span>
      </li>
      <!-- <li>
        <span class="headerItem" @click="()=>this.$router.push('/supply')">
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/gongxu.png" alt=""/>
          <span>Online Matchmaking</span>
          </span>
      </li> -->
      <li>
        <span class="headerItem" @click="()=>webHerf('https://e.cippe.com.cn/live/index_en')">
        <!-- <span class="headerItem" @click="()=>this.$router.push('/live')"> -->
          <img :src="hrefurl+'/public/icon/live.png'" alt=""/>
          <span>Events Live Broadcast</span>
        </span>
      </li>
      <!-- <li v-if="this.user.authent*1==0">
        <span class="headerItem fenge" @click="approve">
          <i></i>
          <img src="https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/icon/approve.png" alt=""/>
          <span style="color:#f08300">Exhibitor Certification</span>
        </span>
      </li> -->
      <li v-if="!isLogin*1">
         <el-button  class="denglu headerItem" type="text" @click.stop="goLogin">
            <img :src="hrefurl+'/public/icon/yonghu.png'" alt=""/>
           
           <span>Login</span></el-button>
          <el-dialog class="approve" :visible.sync="dialogVisible1" width="350px" :modal-append-to-body='false' :close-on-click-modal='false' append-to-body :before-close="close" center>
            <div v-if="cut">
              <h2 class="approveTitle">Email login</h2>
              <el-form :model="emailRuleForm" status-icon ref="emailLogin" class="demo-ruleForm">
                <el-form-item prop="email"
                  :rules="[ { required: true, message: 'Email', trigger: 'blur' },
                    { type: 'email', message: 'Input email address', trigger: ['blur', 'change'] } ]"
                >
                  <el-input v-model="emailRuleForm.email" placeholder="Email"></el-input>
                </el-form-item>
                <el-form-item prop="password" :rules="[{ required: true, message: 'Input password', trigger: '' }]" >
                  <el-input type="password" placeholder="Input password" v-model="emailRuleForm.password" show-password></el-input>
                </el-form-item>
                <el-form-item prop="type" :rules="[{ type: 'array',required: true, message: 'Please fully read and agree to the agreement above', trigger: 'change' }]" class="login_type">
                  <el-checkbox-group v-model="emailRuleForm.type">
                    <el-checkbox label="1" name="type"> I have read and agreed to<span class="agreement" @click.stop="agreement(true)">《Terms of Use》</span><br/>and<span class="agreement" @click.stop="agreement(false)">《Privacy Policy》</span></el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
                <p class="retrieve_password">
                  <span @click="reg">User registration</span>
                  <span @click="retrievePass">Forget password</span>
                </p>
                <el-form-item class="approvebutton" >
                  <el-button class="" type="primary" @click="changeLogin('emailLogin')">Log in</el-button>
                </el-form-item>
              </el-form>
              <div v-if="popup" class="c_mask">
                <div class="c_wrap">
                  <img @click="popup = false" :src="hrefurl+'/public/icon/close.png'" />
                  <div>
                    <div class="c_title">{{vessel.title}}</div>
                    <div class="c_content">
                      <div>
                        <p v-for="(item,i) in vessel.arr" :key="i">{{item}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <span class="sanfang">Login with</span>
              <p class="cutWx"><span @click="cut=false"><img :src="hrefurl+'/public/icon/wx.png'" /></span></p>
            </div>
            <div v-else>
              <wxlogin
              appid="wx5ad2fbf0e05dfda9"
              :scope="'snsapi_login'"
              :theme="'black'"
              :redirect_uri="head+'%3A%2F%2Fe.cippe.com.cn%2Fen%23%2F'+path"
              :href="'data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6IDIwMHB4O30NCiAgICAuaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDIwMHB4O30NCiAgICAuc3RhdHVzX2ljb24ge2Rpc3BsYXk6IG5vbmV9DQogICAgLmltcG93ZXJCb3ggLnN0YXR1cyB7dGV4dC1hbGlnbjogY2VudGVyO30NCiAgICAuaW1wb3dlckJveCAuc3RhdHVzLnN0YXR1c19icm93c2Vye2Rpc3BsYXk6IGJsb2NrO30NCiAgICAuaW1wb3dlckJveCAuc3RhdHVze2Rpc3BsYXk6IGJsb2NrO30='"
              response_type=code
              state=c3e9d2cbe3d3ccaf03c3f16e3ed963e8
            >
            </wxlogin>
            <p class="cut"><span @click="cut=true">return</span></p>
            </div>
          </el-dialog>
      </li>
      <li v-else class="loginUp" style="position: relative;">
        <span class="headerItem userSpan" @click="()=>{this.$router.push('/user/intentionOrder'); this.$store.dispatch('userTitle',{url:'/user/merchantsCollection',title:'Exhibitor Favorites'})}">
          <img :src="user.img" alt=""/>{{user.name?user.name:user.nickname}}
        </span>
        <ul class="down">
          <li @click="outLogin">Log Out</li>
        </ul>
      </li>
      <li>
        <span class="headerItem fenge" @click="appHerf('https://e.cippe.com.cn/')">
          <span class="qiehuan" >中文(简体)</span>
        </span>
      </li>
    </ul>
    </div>
    <el-dialog
      title="Edit Personal Information"
      :visible.sync="information"
      :append-to-body="true"
      width="700px"
      top="3vh"
      @open='open'
      :before-close="resetForm"
      class="tanchaung"
      center>
      <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
        <el-form-item label="Name" prop="name">
          <el-input  v-model="ruleForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input type= 'email' v-model="ruleForm.email" autocomplete="off" :disabled='true'></el-input>
        </el-form-item>
        <el-form-item label="" prop="code">
          <el-input class="phoneCode" v-model="ruleForm.code" placeholder="Input the verification code"></el-input>
          <el-button class="btn_Code button" type="primary" @click="reqCode" :disabled="disabled">{{countdown}}</el-button>
        </el-form-item>
        <el-form-item label="Company Name" prop="corpname">
          <el-input v-model="ruleForm.corpname"></el-input>
        </el-form-item>
        <el-form-item label="country" prop="country">
          <el-select v-model="ruleForm.country" placeholder="Select country">
            <el-option v-for="(item,i) in country" :key="i" :label="item[2]" :value="item[2]"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Mobile" >
          <el-input v-model.number="ruleForm.mobile"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">Edit</el-button>
          <el-button @click="resetForm('ruleForm')">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import wxlogin from 'vue-wxlogin'
import { mapState } from "vuex";
import { reqLogin, reqLoginEn, reqRetrieveCode, reqMyinfoEditEn } from "../../api";
import { tdist_country, privacy_policy, terms_of_use } from "../../mock/country";
export default {
  components:{wxlogin},
  data(){
    var checkName = (rule, value, callback) => {//M昵称
      if (!value.trim()) {
        return callback(new Error('Name is required'));
      }else{
        callback();
      }
    };
    var checkCorpname = (rule, value, callback) => {
      if (!value.trim()) {
        return callback(new Error('Company Name'));
      }else{
        callback();
      }
    };
    var checkCode = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("Input the verification code"));
      } else {
          callback();
      }
    };
    return{
      rules: {
        name: [
          { required: true,validator: checkName, trigger: 'blur' }
        ],
        // email: [
        //   { required: true, validateEmail, trigger: 'blur' },
        // ],
        corpname: [
          { required: true,validator: checkCorpname, trigger: 'blur' }
        ],
        country:[
          { required: true, message: '国家不能为空', trigger: 'change' }],
        // duties: [
        //   { required: true,validator: checkDuties, trigger: 'blur' }
        // ],
        // mobile: [
        //   { required: true,validator: checkPhone, trigger: 'blur' }
        // ],
        mobileVerify: [
          { required: true,validator: checkCode, trigger: 'blur' }
        ]
      },
      ruleForm: {
        name: '',
        email: '',
        corpname: '',
        // duties:'',
        mobile:'',
        // mobileVerify:'',
        code:'',
        country:''
      },
      disabled:false,//发送验证码
      countdown:"Send verification code",//倒计时
      flagCode:false,
      approveState:false,//认证状态
      approveData:{
        username:"",//认证账号
        password:"",//认证密码
      },
      emailRuleForm: {
        email: '',
        password: '',
        state:'',//滑块状态
        type:[]
      },
      country:[],//国家
      popup:false,
      vessel:{
        title:'',
        arr:[]
      },
      cut:true, // 登录方式切换
    }
  },
  mounted(){
    this.country = tdist_country
  },
  methods:{
    close(){//关闭登录框
      this.$store.dispatch("dialog",false)
      this.$refs.emailLogin.resetFields();
      // this.country = tdist_country
    },
    async changeLogin(formName){//登录请求
      this.$refs[formName].validate( async (valid) => {
        if (valid) {//提交表单数据，发送请求
          const response = await reqLoginEn(this.emailRuleForm)
          if (response.code*1==1) {
            this.$store.dispatch('userInformation',response.resilt)
            this.$store.dispatch('isLogin',1)
            this.$refs[formName].resetFields();
          }else{
            this.err(this,'login failed')
          }
        } else {
          return false;
        }
      });
    },

    async changeEmailLogin(i){//微信登录请求
      let url = i.split('?')
      if (url.length<=1) return 
      let data = {}
      url = url[1].split('&')
      data[url[0].split("=")[0]] = url[0].split("=")[1]
      data[url[1].split("=")[0]] = url[1].split("=")[1]
      const response = await reqLogin(data.code,data.state)
      if ((response.code)*1==1) {
        this.$store.dispatch("dialog",false)
        this.$store.dispatch("userInformation",response.resilt)
        this.$store.dispatch("isLogin",1)
        this.$router.push("/"+this.path)
      }else if ((response.code)*1==0) {
        this.err(this,"添加失败，请重试。。。")
      }else if ((response.code)*1==2) {
        this.err(this,"授权失败，请重试。。。")
      }
    },
    goLogin(){//登录成功
      this.isPath1(this)
      this.$store.dispatch("dialog",true)
    },
    outLogin(){//退出登录
      this.$store.dispatch("outLogin")
      this.$router.push("/home")
    },
    approve(){//展商认证
      if (this.user.status*1==0) {
        this.open()
        // this.
      }else{
        this.approveState=true
      }
    },
    async reqCode(){//获取验证码
      const response = await reqRetrieveCode({email:this.ruleForm.email})
      if (response.code==3) {
        this.success(this,"The verification code was sent successfully!")
        this.countdown = 90
        this.disabled = true
        this.time()
      }else if(response.code*1==1){
        this.err(this,"邮箱不存在")
      }else{
        this.err(this,"The verification code failed to be sent, please try again later")
        this.countdown = "Send verification code"
      }
    },
    time(){//倒计时
      this.timer = setInterval(()=>{
        this.countdown--
        if (this.countdown<=0) {
          clearInterval(this.timer)
          this.countdown = "Send verification code"
          this.disabled = false
        }
      },1000)
    },
    submitForm(formName) {//提交表单
      this.$refs[formName].validate( async (valid) => {
        if (valid) {//提交表单数据，发送请求
          const response = await reqMyinfoEditEn(this.ruleForm)
          if (response.code*1 == 2) {
            this.$store.dispatch("userInformation",response.resilt)
            this.success(this,'Edit Successfully')
            this.countdown = "Send verification code"
            clearInterval(this.timer)
            this.$store.dispatch("information",false)
            if (this.user.authent*1==0) {
              this.approveState=true
            }
          // }else if(response.code == 3){
          //   this.err(this,'验证码不正确,请重新输入...')
          }else {
            this.err(this,'Timeout, please try...')
          }
        } else {
          return false;
        }
      });
    },
    resetForm() {//清空表单
      clearInterval(this.timer)
      this.countdown = "Send verification code"
      this.$store.dispatch("information",false)
    },


    open(){//打开修改弹窗
      //根据获取来的个人信息 初始显示表单数据
      let {name, email, corpname, duties, mobile} = this.user
      this.ruleForm={
        name,
        email,
        corpname,
        duties,
        mobile,
      }
      if (mobile) {
        this.disabled = false
      }
    },

    web(){
      this.webHerf('https://en.cippe.com.cn/')
    },
    reg(){//注册
      this.close()
      this.$router.push('/registered/2')
    },
    retrievePass(){//注册
      this.close()
      this.$router.push('/retrievePass')
    },
    agreement(falg){//协议跳转
      if (falg) {
        this.popup = true
        this.vessel = terms_of_use
      }else{
        this.popup = true
        this.vessel = privacy_policy
      }
    },
  },
  computed:{
    ...mapState({
      user:state=>state.user.user,
      isLogin:state=>state.user.isLogin,
      dialogVisible1:state=>state.user.dialogVisible1,
      path:state=>state.user.path,
      head:state=>state.user.head,
      information:state=>state.user.information
    }),
  },
  watch:{
    $route:function(to){
      console.log(to);
      this.changeEmailLogin(to.fullPath)
    }
  },
}
</script>

<style scoped>
  .nav{
    user-select: none;
    width: 100%;
    background-color: #008baf;
    position: fixed;
    left: 0;
    top: 0;
    border-bottom: 1px solid #fff;
    z-index: 999;
  }
  .w{
    width: 100%;
    max-width: 1200px;
    margin: 0 auto;
  }
  .nav .w>div{
    float: left;
    padding-top: 6px;
    width: 200px;
  }
  .nav .w>div>img{
    /* max-width: 141px; */
  }
  .nav ul{
    height: 60px;
    text-align: center;
    background-color: #008baf;
    margin: 0 auto;
    float: right;
  }
  .nav li{
    display: inline-block;
  }
  .nav>>>.el-button--text,
  .nav li >span{
    line-height: 60px;
    padding: 0 10px;
    font-size: 17px;
    color: white;
    display: inline-block;
    font-family:'FjallaOne-Regular';
  }
  .headerItem{
    cursor: pointer;
    display: inline-block;
    vertical-align: middle;
  }
  .headerItem span{
    font-family: 'FjallaOne-Regular';
  }
  .nav li>.fenge{
    padding-left: 0;
  }
  .nav .fenge>i{
    height: 30px;
    width: 2px;
    background-color: #aaa;
    display: inline-block;
    vertical-align:middle;
    margin-right: 20px;
  }
  .nav li img{
    width: auto;
    height: 20px;
    vertical-align: text-bottom;
    margin-right: 2px;
  }
  .headerItem:hover span{
    /* text-decoration: underline; */
    border-bottom: 2px solid white;
    line-height: 26px;
    display: inline-block;
  }
  .dialog>>>.el-dialog__body{
    padding: 0;
  }
  .userSpan{
    /* width: 130px; */
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 130px;
  }
  .userSpan>img{
    width: 24px;
    height: 24px;
    overflow: hidden;
    border-radius: 50%;
    margin-right: 4px;
  }
  .loginUp{
    position: relative;
  }
  .loginUp .down{
    display: none;
    position: absolute;
    background-color: #ffffff;
    left: 0;
    top: 50px;
    width: 120px;
    height: auto;
    border-top: 1px solid #aaa;
    box-shadow: 1px 1px 4px #aaa;
    z-index: 9999;
  }
  .loginUp:hover .down{
    display: block;
  }
  .loginUp .down li{
    cursor: pointer;
    color: #000;
    padding: 10px 0;
    text-align: center;
    width: 100%;
    transition: all .2s;
  }
  .loginUp .down li:hover{
    text-decoration: underline;
  }
  .nav .headerItem .qiehuan{
    letter-spacing: 0;
    padding: 2px 4px;
    border: 1px solid;
    line-height: 18px;
    display: inline-block;
    font-size: 12px;
    font-weight: 400;
    border-radius: 4px;
    transition: all .5s;
  }
  .nav .headerItem .qiehuan:hover{
    color: #333;
    border-color: #666;
  }
  .sanfang{
    display: block;
    position: absolute;
    left: 38%;
    text-align: center;
    width: 24%;
    background-color: white;
  }
  .cutWx{
    /* text-align: right; */
    line-height: 30px;
    font-size: 14px;
    user-select: none;
    border-top: 1px dashed #aaa;
    margin-top: 32px;
    padding-top: 10px;
    text-align: center;
  }
  .cut{
    text-align: center;
    line-height: 30px;
    font-size: 14px;
    padding: 11px 0px 0;
    user-select: none;
  }
  .cutWx span,
  .cut span{
    cursor: pointer;
  }
  .cutWx span:hover,
  .cut span:hover{
    color: #008baf;
  }
  .cutWx img{
    width: 25px;
  }


   /* 修改个人资料 start */
  .tanchaung >>>.el-input__inner{
    color: #333;
  }
  .tanchaung >>> .el-select{
    width: 100%;
  }
  .tanchaung >>>.el-dialog--center .el-dialog__body{
    padding-left: 100px;
    padding-right: 120px;
    text-align: center;
  }
  .tanchaung >>>.el-button{
    min-width: 100px;
  }
  .tanchaung >>>.el-button+.el-button{
    background-color: white;
  }
  .tanchaung >>>.el-button+.el-button{
    margin-left: 20px;
  }
  .button{
    width: 40%;
    height: 40px;
    padding-left: 0;
    padding-right: 0;
  }
  .phoneCode{
    width: 56%;
    margin-right: 4%;
  }

  /* 修改个人资料 end */

  /* 认证登录 satrt */
  .approve>>>.el-dialog__body{
    padding: 10px 30px 20px;
  }
  .approveTitle{
    text-align: center;
    line-height: 1.6;
    margin-bottom: 30px;
    color: #333;
    font-size: 30px;
    color: #008baf;
    font-weight: 600;
  }
  .retrieve_password{
    font-size: 12px;
    text-align: center;
    padding-bottom: 20px;
  }
  .retrieve_password>span{
    cursor: pointer;
  }
  .retrieve_password span + span{
    margin-left: 20px;
  }
  .retrieve_password>span:hover{
    color: #008baf;
  }
  
  .approvebutton{
    text-align: center;
  }
  .approvebutton>>>.el-button+.el-button{
    margin-left: 20px;
  }
  .approvebutton>>>.el-button{
    height: 40px;
    line-height: 1;
    width: 100%;
  }
  .login_type>>> .el-form-item__content span{
    font-size: 12px;
    vertical-align: top;
  }
  .agreement{
    color: #008baf;
  }
  /* 认证登录 end */
</style>
<style scoped>
  .c_mask{
    z-index: 99994;
    position: fixed;
    overflow: auto;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(55,55,55,.6);
    outline: 0;
    z-index: 3000;
  }
  .c_wrap{
    margin: 0 auto;
    position: relative;
    top: 100px;
    outline: 0;
    /* background-color: white; */
    width: 100%;
    max-width: 500px;
    padding: 10px;
  }
  .c_wrap>img{
    z-index: 1;
    position: absolute;
    right: 18px;
    top: 18px;
    width: 30px;
    height: auto;
    cursor: pointer;
  }
  .c_wrap>div{
    background-color: white;
  }
  .c_title{
    margin: 0 30px;
    padding: 16px;
    text-align: center;
    border-bottom: 1px solid  #e2e2e2;
    font-size: 18px;

  }

  .c_content{
    padding: 24px 30px;
    font-size: 12px;
    line-height: 1.5;
  }
  .c_content>div{
    padding-right: 8px;
    max-height: 260px;
    overflow-y: auto;
  }
  .c_content p{
    text-align: justify;
    margin-bottom: 10px;
    word-break: normal;
    line-height: 24px;
  }
  
</style>